<div class="glu-notification glu-notification-{{type}}">
    <div class="glu-notification-content">
        <button type="button" class="close" data-action="close" aria-hidden="true">{{icon "cancel"}}</button>
        <p>{{ message }}</p>
    </div>
</div>